import React from "react";
import { Control } from "react-hook-form";

import CpvCodeSelect from "../../form_components/CpvCodeSelect";
import { FrameworkFilters } from "../utils";

import css from "./SharedFilterGroups.module.scss";

export interface CPVCodeFilterContentProps {
  control: Control<FrameworkFilters, unknown>;
}

function CPVCodeFilterContent({ control }: CPVCodeFilterContentProps) {
  return (
    <div className={css.filterSection} aria-label="CPVCode filters">
      <CpvCodeSelect hideLabel hideClear name="cpvCodes" label="CPV Codes" control={control} />
    </div>
  );
}

export default CPVCodeFilterContent;
